import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { LOG_MYSTAGE } from '@/graphql/mutations/logMyStage';

export const LogMyStageEventService = {
  msb: async (params) => {
    const client = myStageApolloProvider.defaultClient;
    await client.mutate({
      mutation: LOG_MYSTAGE,
      variables: { input: params }
    });
  }
};
